export default __webpack_public_path__ + "static/media/account-not-selected.65860269.svg";